import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Aperture, Menu, X } from "lucide-react";

const links = [
  { label: "Work", id: "onset" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Rates", id: "rates" },
  { label: "Non-Profit", id: "nonprofit" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "bg-white/5 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <Aperture className="w-7 h-7 text-[#D90429] group-hover:rotate-90 transition-transform duration-700" />
          <span className="font-head text-xl font-600 tracking-[0.25em] uppercase text-white">Darrel Boye</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-body text-sm uppercase tracking-[0.15em] text-gray-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-btn"
            onClick={() => scrollTo("booking")}
            className="font-body text-sm uppercase tracking-[0.15em] px-6 py-2.5 bg-[#D90429] text-white hover:bg-[#EF233C] transition-colors duration-300"
          >
            Book Now
          </button>
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => scrollTo(l.id)}
                  className="font-head text-2xl uppercase tracking-tight text-white text-left"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-book-btn"
                onClick={() => scrollTo("booking")}
                className="mt-2 py-3 bg-[#D90429] text-white font-body uppercase tracking-[0.15em] text-sm"
              >
                Book Now
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
